import { type GetPtoDevicesResponseVM } from '@/app/services/solution/types/get-pto-devices';

const ptoDevices: GetPtoDevicesResponseVM = {
  ptoDevicesPerDay: [
    { key: 'TempControlled', name: 'Temp. Controlled' },
    { key: 'RefuseCollectorSingle', name: 'Refuse Collector (1)' },
    { key: 'RefuseCollectorDouble', name: 'Refuse Collector (2)' },
    { key: 'CraneAvg', name: 'Crane (Avg.)' },
    { key: 'CraneHigh', name: 'Crane (High)' },
  ],
  ptoDevicesPerCycle: [
    { key: 'Hooklift', name: 'Hooklift' },
    { key: 'Skiploader', name: 'Skiploader' },
    { key: 'TailLift', name: 'Tail Lift' },
    { key: 'Tipper', name: 'Tipper' },
  ],
};

export default ptoDevices;
